var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.375 15.1251C23.375 18.9201 20.295 22.0001 16.5 22.0001C12.705 22.0001 9.625 18.9201 9.625 15.1251H6.875C6.875 19.9789 10.4637 23.9664 15.125 24.6401V28.8751H17.875V24.6401C22.5363 23.9664 26.125 19.9789 26.125 15.1251H23.375Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.2501C18.7825 19.2501 20.625 17.4076 20.625 15.1251V6.87512C20.625 4.59262 18.7825 2.75012 16.5 2.75012C14.2175 2.75012 12.375 4.59262 12.375 6.87512V15.1251C12.375 17.4076 14.2175 19.2501 16.5 19.2501ZM15.125 6.87512C15.125 6.11887 15.7438 5.50012 16.5 5.50012C17.2562 5.50012 17.875 6.11887 17.875 6.87512V15.1251C17.875 15.8814 17.2562 16.5001 16.5 16.5001C15.7438 16.5001 15.125 15.8814 15.125 15.1251V6.87512Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.2501C18.7825 19.2501 20.625 17.4076 20.625 15.1251V6.87512C20.625 4.59262 18.7825 2.75012 16.5 2.75012C14.2175 2.75012 12.375 4.59262 12.375 6.87512V15.1251C12.375 17.4076 14.2175 19.2501 16.5 19.2501Z",
    fill: "#BFBFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.aef04d9c795959279e53e5a497636bca.svg";
export { ForwardRef as ReactComponent };